"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Dialog = require("../../shared/Dialog/DialogActions");
const validator = require("validator");
const utils_1 = require("../../utils");
const LandingStore_1 = require("../LandingStore");
const constants_1 = require("../../constants");
const util_1 = require("util");
const api_1 = require("../../api");
const react_bootstrap_1 = require("react-bootstrap");
class ForgotPassword extends React.Component {
    constructor(props) {
        super(props);
        this.email = "";
        this.forgot = this.forgot.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.state = {
            state: constants_1.ProgressState.None,
            shouldUpdate: true
        };
    }
    forgot() {
        if (this.isValid()) {
            this.setState({ shouldUpdate: true });
            api_1.doGet(api_1.API.v1.FORGOT_PASS.replace(':email', this.email)).then(response => {
                this.setState({ state: constants_1.ProgressState.Success, forgotMessage: "success" });
            }).catch(error => {
                api_1.dispatchError(error, () => {
                    error.response.data.map(err => {
                        this.setState({ state: constants_1.ProgressState.Failed, forgotMessage: 'failed' });
                    });
                });
            });
        }
    }
    handleKeyPress(target) {
        if (target.charCode == 13) {
            this.forgot();
        }
    }
    shouldComponentUpdate() {
        return this.state.shouldUpdate;
    }
    render() {
        let forgot_message;
        if (!util_1.isNullOrUndefined(this.state.forgotMessage)) {
            if (this.state.forgotMessage == 'success') {
                this.props.openModal(LandingStore_1.LandingModal.Closed);
                Dialog.showAlertDialog({
                    title: "Password reset",
                    message: "A new password is sent to Your email."
                });
            } else if (this.state.forgotMessage == 'failed') {
                forgot_message = React.createElement("div", { className: "text-center login-panel-error" }, " A user with this email address does not exist");
            }
        }
        return React.createElement(react_bootstrap_1.Modal, { show: true, onHide: () => {}, className: "landing-modal" }, React.createElement(react_bootstrap_1.Modal.Body, { className: "landing-modal-body" }, React.createElement(react_bootstrap_1.Panel, { className: "login-panel" }, React.createElement("div", { className: "modal-close" }, React.createElement("a", { href: "javascript:void(0)", onClick: () => {
                this.props.openModal(LandingStore_1.LandingModal.Closed);
            } }, "Close")), React.createElement("div", { className: "userpic" }, React.createElement("img", { src: "../img/default_profile.png", alt: "" })), React.createElement("div", { className: "panel-body" }, React.createElement("h2", { className: "text-center" }, "Reset Password"), forgot_message, React.createElement("fieldset", null, React.createElement(react_bootstrap_1.FormGroup, Object.assign({ controlId: "email" }, utils_1.FormUtils.formGroupAttributes(this.state.email)), React.createElement(react_bootstrap_1.FormControl, { placeholder: "Email", name: "email", onKeyPress: this.handleKeyPress, type: "email", onChange: event => utils_1.FormUtils.dataChanged(event, this) })), utils_1.FormUtils.showErrorBlock(this.state.email), React.createElement("br", null), React.createElement(react_bootstrap_1.Button, { type: "submit", bsSize: "large", bsStyle: "primary", title: "Reset", block: true, onClick: () => this.forgot() }, "Reset")), React.createElement("br", null), React.createElement("br", null), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 6, mdOffset: 6, className: "text-right" }, React.createElement("a", { href: "javascript:void(0)", onClick: () => {
                this.props.openModal(LandingStore_1.LandingModal.Login);
            } }, "Login now!")))))));
    }
    isValid() {
        let valid = true;
        if (util_1.isNullOrUndefined(this.email) || validator.isEmpty(this.email)) {
            this.setState({
                email: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Email can't be blank."
                }
            });
        } else if (!validator.isEmail(this.email)) {
            this.setState({
                email: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Not valid email format."
                }
            });
        } else {
            this.setState({
                email: {
                    state: constants_1.ProgressState.Success
                }
            });
        }
        return valid;
    }
}
exports.default = ForgotPassword;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/components/ForgotPassword.tsx
// module id = 1064
// module chunks = 0 1